import { useEffect } from "react";
import { BenefitsSection } from "@/components/landing/BenefitsSection";

const WhyDuri = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Why Duri - Duri Ridesharing";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-cream font-roboto">
      <main>
        <BenefitsSection />
      </main>
    </div>
  );
};

export default WhyDuri;
